/**
 * Created by smizrahi on 8/17/16.
 */

import Logger from "../../utils/Logger";
import Persistence from "../../persistence/Persistence"

const UID_KEY = 'UID';

export default class UIDGeneratorPersist extends Persistence {

    constructor() {
        super(true); // True is set to enable cookies fallback
    }

    /**
     * Save the UID into local storage or cookie
     *
     * @param uid
     */
    saveUID(uid) {
        this.set(UID_KEY, uid);
    }

    /**
     * Load the UID from local storage or cookie
     *
     * @returns {*} The UID
     */
    loadUID() {
        let uid = this.get(UID_KEY);
        Logger.log("Loading UID from cache : " + uid);
        return uid;
    }
}


// WEBPACK FOOTER //
// ./js/core/UIDGenerator/persistence/UIDGeneratorPersist.js